(() => {
  'use strict';

  if (window.__llStep80SectionLazyBooted) return;
  window.__llStep80SectionLazyBooted = true;

  const SELECTOR = '[data-ll-step80-section]';
  const EXECUTABLE_TYPES = new Set(['', 'text/javascript', 'application/javascript', 'module']);
  const loading = new Map();
  const FIRST_SCROLL_WARM_COUNT = 3;
  let observer = null;
  let started = false;

  const placeholders = () => Array.from(document.querySelectorAll(SELECTOR));

  const sectionIdFrom = (el) => el && el.getAttribute('data-ll-step80-section');

  const isExecutableScript = (script) => {
    const type = (script.getAttribute('type') || '').trim().toLowerCase();
    return EXECUTABLE_TYPES.has(type);
  };

  const activateScripts = (root) => {
    const scripts = Array.from(root.querySelectorAll('script')).filter(isExecutableScript);

    scripts.forEach((oldScript) => {
      const script = document.createElement('script');

      Array.from(oldScript.attributes).forEach((attr) => {
        script.setAttribute(attr.name, attr.value);
      });

      if (oldScript.src && !oldScript.hasAttribute('async') && (oldScript.getAttribute('type') || '').toLowerCase() !== 'module') {
        script.async = false;
      }

      if (!oldScript.src) script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  };

  const mountSection = (id, html) => {
    if (!id || !html) return false;

    const current = document.getElementById(`shopify-section-${id}`);
    if (!current) return false;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.getElementById(`shopify-section-${id}`);
    if (!next) return false;

    const imported = document.importNode(next, true);
    current.replaceWith(imported);
    activateScripts(imported);

    document.dispatchEvent(new CustomEvent('ll:step80:section-loaded', {
      detail: { sectionId: id }
    }));

    return true;
  };

  const requestSections = async (ids) => {
    const unique = Array.from(new Set(ids.filter(Boolean))).filter((id) => {
      const el = document.querySelector(`${SELECTOR}[data-ll-step80-section="${CSS.escape(id)}"]`);
      return Boolean(el) && !loading.has(id);
    });

    if (!unique.length) return;

    const promise = (async () => {
      const url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      url.searchParams.set('sections', unique.join(','));

      try {
        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error(`Section request failed: ${response.status}`);

        const data = await response.json();
        unique.forEach((id) => {
          if (data && data[id]) mountSection(id, data[id]);
        });
      } catch (error) {
        console.warn('[LUCID LOOM STEP80] Deferred section load failed.', error);
      } finally {
        unique.forEach((id) => loading.delete(id));
      }
    })();

    unique.forEach((id) => loading.set(id, promise));
    return promise;
  };

  const requestOne = (el) => {
    const id = sectionIdFrom(el);
    if (!id) return;
    requestSections([id]);
  };

  const armObserver = () => {
    if (!('IntersectionObserver' in window)) {
      const rest = placeholders().slice(FIRST_SCROLL_WARM_COUNT).map(sectionIdFrom);
      requestSections(rest.slice(0, 5));
      return;
    }

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        requestOne(entry.target);
      });
    }, { root: null, rootMargin: '1100px 0px', threshold: 0.01 });

    placeholders().forEach((el, index) => {
      if (index >= FIRST_SCROLL_WARM_COUNT) observer.observe(el);
    });
  };

  const start = () => {
    if (started) return;
    started = true;

    const current = placeholders();
    if (!current.length) return;

    // The first deferred homepage sections are fetched immediately after
    // the customer's first real scroll. Keep Lookbook + Product Cards + Motif
    // warming together so STEP87/STEP80 timing remains ahead of the viewport.
    requestSections(current.slice(0, FIRST_SCROLL_WARM_COUNT).map(sectionIdFrom));
    armObserver();
  };

  const onFirstScroll = () => {
    start();
  };

  window.addEventListener('scroll', onFirstScroll, { once: true, passive: true });

  // Keyboard navigation can jump the page before a native scroll event is delivered.
  window.addEventListener('keydown', (event) => {
    if (started) return;
    if (['PageDown', 'End', 'ArrowDown', ' '].includes(event.key)) start();
  }, { once: true, passive: true });

  // BFCache restores can return already scrolled. In that case hydrate immediately.
  window.addEventListener('pageshow', (event) => {
    if ((event.persisted || window.scrollY > 40) && !started) start();
  }, { once: true });
})();
//# sourceURL=ll-step80-homepage-section-lazy.js
